export default [
  {
    path: "/backoffice/groups",
    name: "Groups",
    meta: { requiresAuth: true, breadcrumb: [
      { label: "BackOffice", to: "/" },
      { label: "Groups" },
    ] },
    component: () =>
      import(
        /* webpackChunkName: "groups" */ "@/views/backoffice/Groups/Groups.vue"
      ),
  },
  {
    path: "/backoffice/groups/create",
    name: "CreateGroup",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Groups", to: "/backoffice/groups" },
        { label: "Create Group" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "groups" */ "@/views/backoffice/Groups/GroupCreatePage/GroupCreatePage.vue"
      ),
  },
];
